import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { SalaryDeviationReportButtonsProps } from "models/propTypes/salaryDeviationPropTypes";
import { TranslationKeys } from "translations";
//endregion
//#region components
import { StyledButton } from "components/common";
import useCreateAllowanceDialog from "../forms/useCreateAllowanceDialog";
import useCreateLeaveDialog from "../forms/useCreateLeaveDialog";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SalaryDeviationReportTodoButtons: React.FC<SalaryDeviationReportButtonsProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const { salaryDeviationReport, reloadList } = props;

  const getAllowanceDialog = useCreateAllowanceDialog(reloadList);
  const getLeaveDialog = useCreateLeaveDialog(reloadList);

  const onNewCompensationClick = () => {
    dispatch(displayDialog(getAllowanceDialog({ yearMonth: salaryDeviationReport?.yearMonth })));
  };

  const onNewTimeDeviationClick = () => {
    dispatch(displayDialog(getLeaveDialog({ yearMonth: salaryDeviationReport?.yearMonth })));
  };

  return (
    <Grid container direction="row" spacing={1} className={cssExports.titledContainerButtons}>
      <Grid item>
        <StyledButton size="sm" secondary onClick={onNewCompensationClick}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AddReimbursement)}
        </StyledButton>
      </Grid>
      <Grid item>
        <StyledButton size="sm" secondary onClick={onNewTimeDeviationClick}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.AddTimeDeviation)}
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default SalaryDeviationReportTodoButtons;
